module.exports = __webpack_public_path__ + "static/img/curieux_shadow.5e6bc9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/curieux_shadow.png
// module id = RT6L
// module chunks = 0